// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"src-views-Search-styles-module__searchInput--3NCkg"};